var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"search-card search-card--category",attrs:{"to":{
    name: _vm.data.child_categories && _vm.data.child_categories.length ? 'category-main' : 'category-open',
    params: { link: _vm.data.link },
  }}},[_c('ImgComponent',{staticClass:"search-card__img",attrs:{"img":_vm.data.site_square_img,"width":"100","height":"100","contain":""}}),_c('div',{staticClass:"search-card__info"},[_c('span',{staticClass:"search-card__title"},[_vm._v(_vm._s(_vm.data.title))])]),_c('RemixIconComponent',{attrs:{"category":"system","name":"arrow-right-s-line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }